module.exports = __webpack_public_path__ + "img/sign.1e7c8590.jpg";